const { signIn, signUp, getProfile, setNewAddress, getWarehouseAddress, setWarehouseAddress, recoveryPw, refreshToken, updateProfile } = require('@/controllers/users').ct_users;

const state = {
    user_logged: false,
    email: null,
    user_data: null,
    access_token: null,
    sidebar_collapsed: false,
};

const mutations = {
    SET_USER_INFO(state, { email, user_data, access_token }) {
        state.user_logged = true;
        state.email = email;
        state.user_data = user_data;
        state.access_token = access_token;
    },
    ERASE_USER_INFO(state) {
        state.user_logged = false;
        state.email = null;
        state.user_data = null;
        state.access_token = null;
    },
    SET_ACCESS_TOKEN(state, token) {
        state.access_token = token;
    },
    SET_SIDEBAR_COLLAPSED(state, value) {
        state.sidebar_collapsed = value;
    },
};

const getters = {
    get_user_data(state) {
        return state;
    },
    get_sidebar_collapsed(state) {
        return state.sidebar_collapsed;
    },
};


const actions = {
    async login({ commit }, payload) {
        try {
            const { email, password, rememberMe = false } = payload;

            if (!email || !password) {
                throw "Precisa fornecer um e-mail e uma senha";
            }

            const response = await signIn({ email, password, keepLogged: rememberMe });

            if (!response.status) {
                throw response.error
            }

            const { access_token } = response;

            const user_data = await getProfile({ access_token });

            commit('SET_USER_INFO', { email, user_data, access_token });

        } catch (error) {
            throw error;
        }
    },

    async register({ dispatch }, payload) {
        try {
            payload.phone = payload.phone.replace(/\D/g, '');

            const response = await signUp(payload);

            if (!response.status) {
                throw response.error
            }

            if (!response.stage) {
                throw "Aconteceu um erro inesperado, por favor tente novamente ou contate o suporte";
            }

            let success = {
                message: response.message
            };

            if (response.stage === "1/2") {
                success.code_mail = true;
                return success;
            }

            await dispatch('login', { email: payload.email, password: payload.password });

            success.code_mail = false;
            return success;

        } catch (error) {
            throw error;
        }
    },

    async set_new_address({ rootGetters, commit }, payload) {
        try {
            const { access_token, email, ...c_data } = rootGetters['users/get_user_data'];

            payload.access_token = access_token;

            let filteredData = Object.entries(payload).reduce((acc, [key, value]) => value ? { ...acc, [key]: value } : acc, {});

            filteredData = { ...c_data.user_data.company_address, ...filteredData };

            const address = await setNewAddress(filteredData);

            if (!address.status) {
                throw address.error;
            }

            const user_data = await getProfile({ access_token });

            commit('SET_USER_INFO', { email, user_data, access_token });

            return address;
        } catch (error) {
            throw error;
        }
    },

    async get_warehouse_address({ rootGetters }, warehouse_id) {
        try {
            const { access_token } = rootGetters['users/get_user_data'];
            const result = await getWarehouseAddress(access_token, warehouse_id);
            if (!result.status) throw result.error;
            return result;
        } catch (error) {
            throw error;
        }
    },

    async set_warehouse_address({ rootGetters }, { warehouse_id, ...payload }) {
        try {
            const { access_token } = rootGetters['users/get_user_data'];

            payload.access_token = access_token;

            const address = await setWarehouseAddress(payload, warehouse_id);

            if (!address.status) {
                throw address.error;
            }

            return address;
        } catch (error) {
            throw error;
        }
    },

    logout({ commit }) {
        commit('ERASE_USER_INFO');
        commit('meta/RESET_META_STATE', null, { root: true });
    },


    async refreshProfile({ state, commit }) {
        try {
            const { access_token, email } = state;
            if (!access_token) return;

            const user_data = await getProfile({ access_token });
            if (user_data?.status === false) throw user_data.error;

            commit('SET_USER_INFO', { email, user_data, access_token });
        } catch (error) {
            throw error;
        }
    },

    async update_profile({ rootGetters, commit }, payload) {
        try {
            const { access_token, email } = rootGetters['users/get_user_data'];
            payload.access_token = access_token;

            const result = await updateProfile(payload);
            if (!result.status) throw result.error;

            const user_data = await getProfile({ access_token });
            commit('SET_USER_INFO', { email, user_data, access_token });

            return result;
        } catch (error) {
            throw error;
        }
    },

    async recoveryPassword(_, payload) {
        try {
            if (!payload.email) {
                throw "Condições de redefinição de senha inválidas";
            }

            const response = await recoveryPw(payload);

            if (!response.status) {
                throw response.error
            }

            let success = {
                message: response.message
            };

            return success;
        } catch (error) {
            throw error;
        }
    }
};

const user = {
    namespaced: true,
    state,
    mutations,
    getters,
    actions
}


export default user;